module.exports = __webpack_public_path__ + "static/media/attribute-icon.d257a6e4.svg";